import thingApi from '../apis/thing'

const state = {
  commentList: [],
  commentPic: [],
  activities: {
    data: []
  }
}

const actions = {
  getCMsg ({commit, state}, {type, cType, id, perPage, page, cb}) {
    thingApi.getCMsg(
      type,
      cType,
      id,
      perPage,
      page,
      (data) => cb(data)
    )
  },
  submitMsg ({commit, state}, {cType, data, cb}) {
    thingApi.submitMsg(
      cType,
      data,
      (data) => cb(data)
    )
  },
  traceItem ({commit}, {type, id, isTrace}) {
    return thingApi.traceItem(type, id, isTrace)
  },
  uploadImg ({commit, state}, {file, type, cb}) {
    thingApi.uploadImgNew(
      file,
      type,
      1,
      (data) => cb(data)
    )
  },
  removeCommentPic ({commit, state}, {i}) {
    commit('deleteCommentPic', {i})
  },
  sendFeedBack ({commit}, {data, cb}) {
    thingApi.sendFeedBack(
      data,
      (data) => cb(data)
    )
  },
  updateStatus ({commit}, {type, id, status}) {
    return thingApi.updateStatus(
      type,
      id,
      status
    )
  },
  getCurrentActivities ({commit, state}) {
    return thingApi.getCurrentActivities()
      .then(data => commit('setActivities', {data}))
  },
  receiveCurrentActivity ({commit, state}, {id, cb}) {
    thingApi.receiveCurrentActivity(id, (data) => {
      cb(data)
    })
  },
  report ({commit, state}, {type, id, reason, cb = null} = {}) {
    thingApi.report(
      type,
      id,
      reason,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  }
}

const mutations = {
  setCommentList (state, {data}) {
    state.commentList = data
  },
  setCommentPic (state, {data}) {
    state.commentPic = [
      ...state.commentPic,
      data
    ]
  },
  deleteCommentPic (state, {i}) {
    state.commentPic = state.commentPic.filter((item, index) => i !== index)
  },
  setActivities (state, {data}) {
    state.activities = data
  }
}

export default{
  state,
  actions,
  mutations
}
